import { DEFAULT_DENSITY, DENSITY_PRESETS, GRID_DENSITIES, stepDensity, useGridDensity, type GridView } from '@/utils/gridDensity';

const btn = (disabled: boolean) => ({
  padding: '3px 8px', fontSize: 11, fontWeight: 700, borderRadius: 6, border: '1px solid #e2e8f0',
  background: 'white', color: disabled ? '#cbd5e1' : '#475569', cursor: disabled ? 'default' : 'pointer', lineHeight: 1.2,
}) as const;

/**
 * A− / A+ for the counter or officer grid, remembered per device. Each step grows or shrinks row
 * height, text and column width together; the middle readout is the current size and resets
 * to 100% when clicked.
 */
export function GridDensitySelect({ view = 'counter' }: { view?: GridView }) {
  const [density, setDensity] = useGridDensity(view);
  const atMin = density === GRID_DENSITIES[0];
  const atDefault = density === DEFAULT_DENSITY;
  const atMax = density === GRID_DENSITIES[GRID_DENSITIES.length - 1];
  const what = view === 'officer' ? 'officer grid' : 'grid';
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, flexShrink: 0 }}>
      <button
        type="button" aria-label={`Decrease ${what} size`} title="Smaller grid text and rows"
        disabled={atMin} onClick={() => setDensity(stepDensity(density, -1))} style={btn(atMin)}
      >A−</button>
      <button
        type="button" aria-label={`Reset ${what} size`} title="Reset to 100% — every row on screen"
        disabled={atDefault} onClick={() => setDensity(DEFAULT_DENSITY)}
        style={{ ...btn(atDefault), padding: '3px 4px', minWidth: 34, fontWeight: 600, color: atDefault ? '#94a3b8' : '#475569' }}
      >{DENSITY_PRESETS[density].label}</button>
      <button
        type="button" aria-label={`Increase ${what} size`} title="Larger grid text and rows"
        disabled={atMax} onClick={() => setDensity(stepDensity(density, 1))} style={btn(atMax)}
      >A+</button>
    </span>
  );
}
